import React from 'react';
import styled from 'styled-components'

interface Props {
	phoneDirectoryOwnerInfo: any
}

const OwnerInfo = styled.div`
	margin-left: 20px;
`;

export const PhoneDirectoryOwnerInfo: React.FC<Props> = (props: Props) => {
	const ownerDetails = props.phoneDirectoryOwnerInfo;
	return (
		<OwnerInfo>
			<div>{ownerDetails.name}</div>
			<div>Y-tunnus {ownerDetails.businessId}</div>
		</OwnerInfo>
	)
};